<template>
  <div class="container">
    <el-card>
      <div slot="header">区域管理</div>
      <div style="height: 100%">
        <div>
          <el-button
            type="primary"
            @click="addArea"
            icon="el-icon-plus"
            size="small"
            >添加</el-button
          >
        </div>
        <div class="tableStyle">
          <el-table
            :data="tableData"
           style="width: fit-content"
            height="100%"
            v-loading="loading"
            id="areaManageTable"
            :tree-props="{ children: 'children' }"
            default-expand-all
            row-key="id"
          >
            <el-table-column prop="name" label="上级" width="250">
            </el-table-column>
            <el-table-column label="操作" align="center" width="250">
              <template slot-scope="scope">
                <!-- <el-button -->
                <el-button
                  size="mini"
                  type="text"
                  icon="el-icon-plus"
                  :disabled="scope.row.type == 0"
                  @click="addArea(scope.row)"
                  >新增</el-button
                >
                <el-button
                  size="mini"
                  type="text"
                  icon="el-icon-edit"
                  @click="editArea(scope.row)"
                  >修改</el-button
                >
                <el-button
                  size="mini"
                  type="text"
                  icon="el-icon-delete"
                  @click="deleteArea(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-card>
    <el-dialog
      :title="areaDialogTitle"
      :visible.sync="areaDialogVisible"
      width="30%"
    >
      <el-form :model="areaForm" label-width="80px">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="上级">
              <el-select
                v-model="areaForm.parentId"
                placeholder="请选择"
                disabled
              >
                <el-option
                  v-for="item in areaOptions"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="名称">
              <el-input v-model="areaForm.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="areaDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { translateObjectEmptyAttributeToNull } from '../../untils/func';
import {
  selectTreeList,
  save,
  detail,
  remove,
} from '../../api/property/areaManage';
import { selectSensorDistrict } from '../../api/comboboxLoad';
export default {
  data() {
    return {
      form: {},
      areaForm: {},
      areaDialogVisible: false,
      areaDialogTitle: '',
      // 字典表格数据
      tableData: [],
      areaOptions: [], //区域options
      // 查询参数
      queryParams: {
        current: 1,
        size: 100,
        createStartTime: '',
        createEndTime: '',
        id: '',
      },
      // 遮罩层
      loading: true,
      total: 0,
      currentRow: null,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  watch: {},
  methods: {
    async init() {
      await this.handleQuery();
      // 下拉列表数据
      await this.getSelectSensorDistrict();
    },
    async handleQuery() {
      this.loading = true;
      let param = this.queryParams;
      param = translateObjectEmptyAttributeToNull(param);
      const response = await selectTreeList(param).then();
      this.tableData = response.data;
      this.total = response.total;
      this.loading = false;
    },
    // 获取下拉列表 数据
    async getSelectSensorDistrict() {
      // 区域
      const res = await selectSensorDistrict().then();
      this.areaOptions = res.data;
    },

    async addArea(row) {
      this.areaForm = {
        parentId: row.id,
        name: '',
      };
      await this.getSelectSensorDistrict();
      this.areaDialogTitle = '添加区域信息';
      this.areaDialogVisible = true;
    },
    async save() {
      await save(this.areaForm).then();
      await this.handleQuery();
      this.msgSuccess('保存成功');
      this.areaDialogVisible = false;
    },
    async editArea(row) {
      await this.viewDetail(row.id);
      this.areaDialogTitle = '编辑电表';
      this.areaDialogVisible = true;
    },
    async viewDetail(id) {
      const res = await detail({ id: id }).then();
      this.areaForm = res.data;
    },
    deleteArea(row) {
      this.$confirm('确定要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await remove(row.id).then();
        this.msgSuccess('删除成功');
        await this.handleQuery();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 10px;
  height: 100%;
}
/deep/ .el-card__header {
  background-color: var(--secondColor) !important;
  color: var(--whiteColor);
}

/deep/ .el-select {
  width: 100%;
}
/deep/ .el-input {
  width: 100%;
}
.searchTag {
  width: 200px;
}
.searchForm {
  margin-top: 15px;
  .el-form-item {
    display: inline-block;
  }
}
.tableStyle {
  height: calc(100% - 40px);
  margin-top: 10px;
  // background-color: pink;
}
</style>
